import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { LogoMark } from "./Logo";

export const Preloader = ({ onDone }) => {
  const [n, setN] = useState(0);
  const [show, setShow] = useState(true);

  useEffect(() => {
    const start = performance.now();
    let id;
    const tick = (t) => {
      const p = Math.min(1, (t - start) / 1400);
      setN(Math.round(p * 100));
      if (p < 1) id = requestAnimationFrame(tick);
      else setShow(false);
    };
    id = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(id);
  }, []);

  return (
    <AnimatePresence onExitComplete={onDone}>
      {show && (
        <motion.div
          data-testid="preloader"
          className="fixed inset-0 z-[100] flex flex-col justify-between bg-[var(--blush)] p-6 text-[var(--ink)] sm:p-10"
          exit={{ clipPath: "inset(0 0 100% 0)" }}
          initial={{ clipPath: "inset(0 0 0% 0)" }}
          transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }}
        >
          <div className="flex items-center justify-between font-mono text-xs uppercase tracking-[0.25em]">
            <LogoMark className="h-10 w-10" />
            <span>Portfolio — 2026</span>
          </div>
          <div className="flex items-end justify-between">
            <span className="font-display text-sm font-bold uppercase tracking-widest">Camila Eterovic</span>
            <span className="font-display text-[22vw] font-extrabold leading-[0.8] tabular-nums sm:text-[14vw]">{n}</span>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
